import { render, staticRenderFns } from "./FieldSentenceLinks.vue?vue&type=template&id=46c206a8&scoped=true&"
import script from "./FieldSentenceLinks.vue?vue&type=script&lang=ts&"
export * from "./FieldSentenceLinks.vue?vue&type=script&lang=ts&"
import style0 from "./FieldSentenceLinks.vue?vue&type=style&index=0&id=46c206a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c206a8",
  null
  
)

export default component.exports